import React from 'react';
import ReactFlow, {
    addEdge,
    useNodesState,
    useEdgesState,
    Background,
    BackgroundVariant,
    ReactFlowProvider,
    useStoreApi,
  } from 'reactflow';

export default function FlowChart({nodes, edges, onNodesChange, onEdgesChange, onConnect, onNodeDrag, onNodeDragStop}) {
  return (
    <>
    <ReactFlow
      nodes={nodes}
      edges={edges}
      onNodesChange={onNodesChange}
      onEdgesChange={onEdgesChange}
      onConnect={onConnect}
      // onNodeDrag={onNodeDrag}
      // onNodeDragStop={onNodeDragStop}
      fitView
    >
      
      <Background variant={BackgroundVariant.Dots} gap={50} />
    </ReactFlow>
    </>
  )
}
